import { GetMarketCodeList } from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

const endPoint = 'market-code-list';

export const getMarketCodeList = async (): Promise<GetMarketCodeList> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};
